import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { Case } from "../../../../models/case";
import { ServiceRequest } from 'src/app/models/service.request';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { Settings } from 'src/app/services/settings';
import { RequestSummary } from "../../../../models/request-summary";
import { ServiceDefService } from "../../../../services/servicedef.service";
import { TransactionHistoryService } from "../../../../services/transactionhistory.service";
import { ServiceRequestType } from 'src/app/models/service-request-type';
import { ServiceDef } from 'src/app/models/service-def';
import { ApproveRequestComponent } from '../../commands/approverequest/approverequest.component';
import { RequestStatusComponent } from '../../commands/req-status/req-status.component';
import { RequestdetailsComponent } from '../../commands/requestdetails/requestdetails.component';
import { MatchComponent } from '../../commands/match/match.component';
import { CollaborateRequestComponent } from '../../commands/collaborate-request/collaborate-request.component';
import { RequestStatus } from 'src/app/models/request-status';
import { MatSort } from '@angular/material/sort';
import { forkJoin } from 'rxjs';

import {
	ConfirmDialogComponent,
	ConfirmDialogModel
} from "../../../../components/shared/confirmation-dialog/confirmation-dialog.component";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { RequestSummaryComponent } from "../../../common-tabs/req-summary/req-summary.component";
import { HouseholdMember } from 'src/app/models/household-member';
import { MatTableDataSource } from '@angular/material/table';
import { CasesService } from 'src/app/services/cases.service';
import { ServiceRequestMembersMap } from 'src/app/models/service-request-members-map';
import { ServiceRequestMemberHistory } from 'src/app/models/service-request-member-history';

@Component({
	selector: 'app-request-summary-tab',
	templateUrl: './request-summary-tab.component.html',
	styleUrls: ['./request-summary-tab.component.css']
})
export class RequestSummaryTabComponent implements OnInit {

	public strErr: string | null = '';

	public regionsDataSource: any;
	public isEditing = false;

	public _caseId = 0;
	public selectedRecord: ServiceRequest;
	public serviceRequestHistory: ServiceRequest
	public caseRecord: Case;
	public requestSummary: RequestSummary;

	/***** Control Strip Button Visibility ***/
	public visibleMatch: boolean | null = false;
	public visibleApprove: boolean | null = false;
	public visibleStatus: boolean | null = false;
	public visibleCollaborate: boolean | null = false;
	public visibleEdit: boolean | null = false;
	public visibleClericalOpen: boolean | null = false;
	public result: boolean | null = false;

	/*** dialog variables ***/
	public displaySearchDlg = false;
	public matchAgencyDlg = false;
	public approveRequestDlg = false;
	public assignStatusDlg = false;

	public selectedServiceRequestTypeId: number;
	public selectedRequestType: ServiceRequestType;

	public selectedServiceDefId: number;
	public selectedDef: ServiceDef;

	public valRequestId = 0;
	public valAmountRequested = 0;
	public serviceRequestTypes;
	public serviceDefs;
	public uomList;
	public startDate;
	public endDate;
	public keepOpen = 0;

	public dialogHeaderText: string = 'Approve Request';
	public requestStatuses: RequestStatus[];
	public unitOfMeasure: string | null = '';
	public Idx: number = -1;
	public primaryAgencyFlag: boolean;
	public clericalOpenAnyAgencyFlag = false;
	public clericalOpenMyAgencyFlag = false;

	public records: HouseholdMember[];
	public recordsAdv: HouseholdMember[];

	public dataSource: MatTableDataSource<HouseholdMember>;
	public dataSourceAdv: MatTableDataSource<HouseholdMember>;
	requestmembersMappings: ServiceRequestMembersMap[];
	public displayedColumns: string[];
	headerSelect = false;
	@ViewChild(MatSort) sort: MatSort;



	@Output() editEvent = new EventEmitter<any>();

	@ViewChild('approveRequest', { static: true }) approveRequest: ApproveRequestComponent;
	@ViewChild('assignStatus', { static: true }) assignStatus: RequestStatusComponent;
	@ViewChild('requestDetails', { static: true }) requestDetails: RequestdetailsComponent;
	@ViewChild('matchAgency', { static: true }) matchAgency: MatchComponent;
	@ViewChild('collaborateReq', { static: true }) collaborateReq: CollaborateRequestComponent;
	@ViewChild('reqSummary', { static: true }) reqSummary: RequestSummaryComponent;

	constructor(private serviceRequestsService: ServiceRequestsService,
		public txService: TransactionHistoryService, public dialog: MatDialog,
		public serviceDefService: ServiceDefService,
		public casesService: CasesService) {
		this.requestSummary = new RequestSummary();
	}

	public ngOnInit() {
		if (Settings.getInstance().regionsList === undefined) {
			this.loadRegionsList();
		}

		this.clericalOpenAnyAgencyFlag = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_REOPEN_ANY_AGENCY', "EXECUTE");
		this.clericalOpenMyAgencyFlag = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_REOPEN_MYAGENCY_TAB', "EXECUTE");

		this.setControlButtons();
		this.displayedColumns = ['select', 'member'];
	}
	public loadMembers() {
		if (this.selectedRecord && (this.selectedRecord.recordStatus === 0 || this.selectedRecord.clericalOpen === 1)) {
			this.loadHistoryMembers();
		} else {
			this.loadLiveMembers();
		}
	}

	/** Middle grid for OPEN requests — live member table + mappings **/
	public loadLiveMembers() {
		this.serviceRequestsService.getHouseholdMembersByCaseId(this._caseId).subscribe(
			(members: any[]) => {
				this.casesService.getServiceRequestMemberMappingsByServiceRequestId(this.selectedRecord.id).subscribe(
					(mapped: any[]) => {
						this.requestmembersMappings = mapped;
						for (let r of members) {
							r.select = false;
							let fullName = [r.firstName, r.middleName, r.lastName].filter(x => x).join(' ');
							r.member = fullName + ' (' + r.relationship + ')';

							for (let m of mapped) {
								if (m.memberId === r.memberId) {
									r.select = true;
									break;
								}
							}
						}

						// exclude advocates
						let filtered = members.filter(r => r.relationship?.trim().toLowerCase() !== 'advocate');

						// put primary applicant (flag = 1) first
						filtered.sort((a, b) => {
							if (a.primaryApplicantFlag === 1 && b.primaryApplicantFlag !== 1) return -1;
							if (a.primaryApplicantFlag !== 1 && b.primaryApplicantFlag === 1) return 1;
							return 0;
						});

						this.records = filtered;
						this.recordsAdv = members.filter(r => r.relationship?.trim().toLowerCase() === 'advocate');

						this.dataSource = new MatTableDataSource(this.records);
						this.dataSourceAdv = new MatTableDataSource(this.recordsAdv);
					},
					() => {
						Settings.getInstance().handleError('Error: unable to retrieve member mappings from the server');
					}
				);
			},
			() => {
				Settings.getInstance().handleError('Error: unable to retrieve family member details from the server');
			}
		);
	}

	/** Middle grid for CLOSED requests — ServiceRequestMemberHistory table **/
	public loadHistoryMembers() {
		if (!this.selectedRecord || this.selectedRecord.id < 1) {
			return;
		}
		this.casesService.getMemberHistory(this.selectedRecord.id).subscribe(
			(historyRecords: ServiceRequestMemberHistory[]) => {
				const mappedRows = historyRecords.map(h => ({
					historyId: h.id,
					select: h.selected === 1,
					memberId: h.memberId,
					member: [h.firstName, h.middleName, h.lastName].filter(x => x).join(' ') + ' (' + h.relationship + ')',
					relationship: h.relationship,
					primaryApplicantFlag: h.relationship?.toLowerCase() === 'self' ? 1 : 0
				}));

				const filtered = mappedRows.filter(r => r.relationship?.trim().toLowerCase() !== 'advocate');
				filtered.sort((a, b) => {
					if (a.primaryApplicantFlag === 1 && b.primaryApplicantFlag !== 1) return -1;
					if (a.primaryApplicantFlag !== 1 && b.primaryApplicantFlag === 1) return 1;
					return 0;
				});

				this.records = filtered as any[];
				this.recordsAdv = mappedRows.filter(r =>
					r.relationship?.trim().toLowerCase() === 'advocate' && r.memberId > 0
				) as any[];
				this.dataSource = new MatTableDataSource(this.records);
				this.dataSourceAdv = new MatTableDataSource(this.recordsAdv);

				const self = historyRecords.find(h => h.relationship === 'Self');
				this.requestSummary.currentNeed = self?.currentNeed || '';
			},
			() => {
				Settings.getInstance().handleError('Error: unable to retrieve member history from the server');
				this.requestSummary.currentNeed = '';
				this.records = [];
				this.recordsAdv = [];
				this.dataSource = new MatTableDataSource(this.records);
				this.dataSourceAdv = new MatTableDataSource(this.recordsAdv);
			}
		);
	}



	public loadRegionsList() {
		this.serviceDefService.getAllRegions().subscribe(
			(result) => {
				Settings.getInstance().regionsList = result;
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve region data from the service');
			}
		)
	}
	public onShowHandler(caseId: number, serviceRequest: ServiceRequest) {
		this._caseId = caseId;
		this.selectedRecord = serviceRequest;
		this.serviceRequestTypes = Settings.getInstance().serviceRequestTypesList;

		/** fetch service defs records **/
		if (serviceRequest.agencyId && serviceRequest.agencyId > 0) {
			this.serviceDefs = Settings.getInstance().serviceDefsList.filter(s => s.agencyId === serviceRequest.agencyId
				&& s.serviceRequestTypeId === this.selectedRecord.serviceRequestTypeId
				&& s.activeStatus === 'Active');

		} else {
			this.serviceDefs = Settings.getInstance().serviceDefsList.filter(s => s.agencyId === Settings.getInstance().loggedInUser.agencyId
				&& s.serviceRequestTypeId === this.selectedRecord.serviceRequestTypeId
				&& s.activeStatus === 'Active');

		}

		this.requestStatuses = Settings.getInstance().requestStatuses;
		this.uomList = Settings.getInstance().uomList;
		this.primaryAgencyFlag = Settings.getInstance().isPrimaryAgency(this.selectedRecord.agencyId);

		this.setControlButtons();
		this.displayDetails();

		if (this._caseId < 1) {
			this.caseRecord = new Case();
			this.requestSummary = new RequestSummary();
			this.displayDetails();
			return;
		}
		if (this.regionsDataSource === undefined) {
			this.regionsDataSource = Settings.getInstance().getCountyDataSource(true);
		}
		this.serviceRequestsService.getCaseById(this._caseId).subscribe(
			(result1) => {
				this.caseRecord = new Case();
				Object.assign(this.caseRecord, result1);

				this.serviceRequestHistory = new ServiceRequest();
				Object.assign(this.caseRecord, result1);
				Object.assign(this.serviceRequestHistory, result1);		/** store the history record. **/
				this.displayDetails();
			},
			(error1) => {
				Settings.getInstance().handleError('Error: unable to retrieve case details from the server');
			}
		);
	}
	presetServiceDefsList() {
		this.serviceDefs = [];
		if (this.selectedRecord.agencyId && this.selectedRecord.agencyId > 0) {
			this.serviceDefs = Settings.getInstance().serviceDefsList.filter(s => s.agencyId === this.selectedRecord.agencyId
				&& s.serviceRequestTypeId === this.selectedServiceRequestTypeId
				&& s.activeStatus === 'Active');

		} else {
			this.serviceDefs = Settings.getInstance().serviceDefsList.filter(s => s.agencyId === Settings.getInstance().loggedInUser.agencyId
				&& s.serviceRequestTypeId === this.selectedServiceRequestTypeId
				&& s.activeStatus === 'Active');

		}
		this.selectedServiceDefId = 0;
	}
	public setControlButtons() {
		if (this.primaryAgencyFlag === undefined) {
			return;
		}
		if (Settings.getInstance().hasPrivilege('REQUEST_DETAIL_EDIT', "SHOW")) {
			this.visibleEdit = this.primaryAgencyFlag;
		} else {
			this.visibleEdit = false;
		}

		if (Settings.getInstance().hasPrivilege('REQUEST_DETAIL_APPROVAL_SHOW', "SHOW")) {
			this.visibleApprove = this.primaryAgencyFlag;
		} else {
			this.visibleApprove = false;
		}

		if (Settings.getInstance().hasPrivilege('REQUEST_DETAIL_DENY_SHOW', "SHOW")) {
			this.visibleStatus = this.primaryAgencyFlag;
		} else {
			this.visibleStatus = false;
		}

		if (Settings.getInstance().hasPrivilege('REQUEST_DETAIL_ASSIGN_SHOW', "SHOW")) {
			this.visibleMatch = true;
		} else {
			this.visibleMatch = false;
		}
		if (this.clericalOpenAnyAgencyFlag) {
			this.visibleClericalOpen = true;
		} else if (this.clericalOpenMyAgencyFlag) {
			if (this.primaryAgencyFlag) {
				this.visibleClericalOpen = true;
			} else {
				this.visibleClericalOpen = false;
			}
		} else {
			this.visibleClericalOpen = false;
		}

		if(!this.primaryAgencyFlag){
			this.visibleCollaborate = Settings.getInstance().hasPrivilege('RESPOND_COLLABORATION', 'SHOW');
		} else{
			this.visibleCollaborate = false;
		}
		
		if (this.selectedRecord && (this.selectedRecord.agencyId === 0 || this.selectedRecord.agencyId === undefined)) {
			this.visibleCollaborate = false;
		}
		if (this.selectedRecord.requestStatusId === 1) {
			this.visibleApprove = false;
			this.visibleStatus = false;
		}
	}
	public submitRecord() {
		let record = this.caseRecord.clone();
		this.strErr = '';

		if (!this.validateFields()) return;

		const finishUpdate = () => {
			this.isEditing = false;
			this.editEvent.emit(this.isEditing);
			this.setRequestSummary();
			this.loadMembers();
			this.updateServiceRecordValues();
		};

		if (this.selectedServiceDefId && this.selectedServiceDefId > 0) {
			this.selectedRecord.requestStatusId = 2;
			if (this.selectedRecord.agencyId === 0) {
				this.selectedRecord.agencyId = Settings.getInstance().loggedInUser.agencyId;
			}
			this.selectedRecord.amountRequested = this.valAmountRequested;
			this.selectedRecord.serviceRequestTypeId = this.selectedServiceRequestTypeId;
			this.selectedRecord.serviceDefId = this.selectedServiceDefId;
			this.selectedRecord.startDate = Settings.getInstance().checkDateChange(this.selectedRecord.startDate, this.startDate);
			this.selectedRecord.endDate = Settings.getInstance().checkDateChange(this.selectedRecord.endDate, this.endDate);
			this.selectedRecord.keepOpen = this.keepOpen ? 1 : 0;
			this.selectedRecord.unitOfMeasure = this.unitOfMeasure;

			this.serviceRequestsService.updateServiceRequestDefDetails(this.selectedRecord).subscribe(
				() => {
					const isClericallyReopened = this.selectedRecord.recordStatus === 0 || this.selectedRecord.clericalOpen === 1;

					if (isClericallyReopened) {
						// For clerically reopened requests: member selections are updated immediately via runChecked()
						// Do not recreate mappings; just finish the update
						finishUpdate();
					} else {
						// For normal open requests: delete and recreate member mappings
						this.casesService.deleteServiceRequestMemberMappingsByServiceRequestId(this.selectedRecord.id).subscribe(
							() => {
								const selectedMappings = this.records
									.filter(r => r['select'])
									.map(r => ({
										serviceRequestId: this.selectedRecord.id,
										caseMemberId: r.id,
										memberId: r.memberId,
										memberType: 'M'
									}));
								const advMappings = this.recordsAdv
									.filter(r => r['select'])
									.map(r => ({
										serviceRequestId: this.selectedRecord.id,
										caseMemberId: r.id,
										memberId: r.memberId,
										memberType: 'A'
									}));

								const allMappings = [...selectedMappings, ...advMappings];

								if (allMappings.length > 0) {
									this.casesService.createServiceRequestMemberMappings(allMappings).subscribe(
										() => finishUpdate(),
										() => this.strErr = 'Error: The server could not create member mappings'
									);
								} else {
									finishUpdate();
								}
							},
							() => this.strErr = 'Error: The server could not update member mappings'
						);
					}
				},
				() => this.strErr = 'Error: The server could not update the case record'
			);

		} else {
			const message = 'These changes will make the record unmatched:  - Are you sure?';
			const dialogData = new ConfirmDialogModel('Please Confirm', message);

			const dialogRef = this.dialog.open(ConfirmDialogComponent, {
				width: '400px',
				data: dialogData,
				panelClass: 'custom-dialog-container'
			});

			dialogRef.afterClosed().subscribe(dialogResult => {
				if (!dialogResult) return;

				this.selectedRecord.amountRequested = this.valAmountRequested;
				this.selectedRecord.serviceRequestTypeId = this.selectedServiceRequestTypeId;
				this.selectedRecord.serviceDefId = this.selectedServiceDefId;
				this.selectedRecord.startDate = Settings.getInstance().checkDateChange(this.selectedRecord.startDate, this.startDate);
				this.selectedRecord.endDate = Settings.getInstance().checkDateChange(this.selectedRecord.endDate, this.endDate);
				this.selectedRecord.unitOfMeasure = this.unitOfMeasure;
				this.selectedRecord.keepOpen = this.keepOpen ? 1 : 0;
				this.selectedRecord.requestStatusId = 1;
				this.selectedRecord.agencyId = 0;
				this.selectedRecord.requestStatusDesc = Settings.getInstance().requestStatuses.find(status => status.id === 1).shortDescription;

				this.serviceRequestsService.updateServiceRequestDefDetails(this.selectedRecord).subscribe(
					() => {
					const isClericallyReopened = this.selectedRecord.recordStatus === 0 || this.selectedRecord.clericalOpen === 1;

					if (isClericallyReopened) {
						// For clerically reopened requests: member selections are updated immediately via runChecked()
						// Do not recreate mappings; just finish the update
						finishUpdate();
					} else {
						// For normal open requests: delete and recreate member mappings
						this.casesService.deleteServiceRequestMemberMappingsByServiceRequestId(this.selectedRecord.id).subscribe(
							() => {
								const selectedMappings = this.records
									.filter(r => r['select'])
									.map(r => ({
										serviceRequestId: this.selectedRecord.id,
										caseMemberId: r.id,
										memberId: r.memberId,
										memberType: 'M'
									}));
								const advMappings = this.recordsAdv
								.filter(r => r['select'])
								.map(r => ({
									serviceRequestId: this.selectedRecord.id,
									caseMemberId: r.id,
									memberId: r.memberId,
									memberType: 'A'
								}));

							const allMappings = [...selectedMappings, ...advMappings];

								if (allMappings.length > 0) {
									this.casesService.createServiceRequestMemberMappings(allMappings).subscribe(
										() => finishUpdate(),
										() => this.strErr = 'Error: The server could not create member mappings'
									);
								} else {
									finishUpdate();
								}
							},
							() => this.strErr = 'Error: The server could not update member mappings'
						);
					}
				},
				() => this.strErr = 'Error: The server could not update the case record'
			);
			});
		}
	}

	public validateFields(): boolean {

		this.strErr = '';
		/* Conneted on 6/19/2024 - Requirement: Enable editing of request type and persist the record even if no matching agency service definition
		if (!this.selectedServiceDefId) {
			this.strErr = 'Please select Agency Service';
			//DwUtils.setFocus(vr.focus_field);
			return false;
		}*/
		if (!this.selectedRequestType) {
			this.strErr = 'Please select Request type';
			//DwUtils.setFocus(vr.focus_field);
			return false;
		}

		if (DwUtils.chkValidDate(this.startDate) === false) {
			this.strErr = 'Error: Badly formed date - should be YYYY-MM-DD';
			DwUtils.highlightFocus('startDateId');
			return false;
		}

		if (DwUtils.chkValidDate(this.endDate) === false) {
			this.strErr = 'Error: Badly formed date - should be YYYY-MM-DD';
			DwUtils.highlightFocus('endDateId');
			return false;
		}

		if (DwUtils.chkDateRange(this.startDate, this.endDate) === false) {
			this.strErr = 'Error: Invalid range: start date is greater than end date';
			DwUtils.highlightFocus('startDateId');
			return false;
		}

		if (!this.unitOfMeasure) {
			this.strErr = 'Please select Unit of Measure';
			return false;
		} else {
			const uom = this.uomList.find(rec => rec.id == this.unitOfMeasure)
			if (!uom) {
				this.strErr = 'Please select Unit of Measure';
				return false;
			}
		}
		const selectedMappings = this.records
			.filter(r => r['select'])
			.map(r => ({
				serviceRequestId: this.selectedRecord.id,
				caseMemberId: r.id,
				memberId: r.memberId
			}));


		if (selectedMappings.length === 0) {
			this.strErr = 'Error: No member associated with this request';
			return false;
		}
		return true;
	}
	public updateServiceRecordValues() {
		this.selectedRecord['agencyName'] = Settings.getInstance().getAgencyName(this.selectedRecord.agencyId);
		this.selectedRecord['serviceRequestDesc'] = Settings.getInstance().getAgencyName(this.selectedRecord.agencyId);

		if (this.selectedRecord.serviceDefId) {
			const serviceDef = Settings.getInstance().getServiceDef(this.selectedRecord.serviceDefId);
			if (serviceDef) {
				this.selectedRecord.serviceRequestDesc = this.getRequestTypeDesc(this.selectedRecord.serviceRequestTypeId) + ': ' + serviceDef.description;
			} else {
				this.selectedRecord.serviceRequestDesc = this.getRequestTypeDesc(this.selectedRecord.serviceRequestTypeId);
			}
		} else {
			this.selectedRecord.serviceRequestDesc = this.getRequestTypeDesc(this.selectedRecord.serviceRequestTypeId);
		}

	}
	public getRequestTypeDesc(paramId: number) {
		if (!this.serviceRequestTypes) {
			return;
		}
		for (const rec of this.serviceRequestTypes) {
			if (rec.id === paramId) {
				return rec.description;
			}
		}
		return 'Undefined';
	}
	public cancelSubmitRecord() {
		this.isEditing = false;
		this.strErr = '';
		this.editEvent.emit(this.isEditing);
		this.onShowHandler(this._caseId, this.selectedRecord);
	}
	public editRecord() {
		this.isEditing = true;
		this.editEvent.emit(this.isEditing);
	}
	public displayDetails() {
		this.loadMembers();
		if (this.selectedRecord) {
			this.setRequestSummary();
		}
	}
	public setRequestSummary(): void {

		this.requestSummary.dateCreated = Settings.getInstance().formatDate(this.selectedRecord.dateCreated);
		this.requestSummary.requestType = this.selectedRecord.serviceRequestDesc;
		this.requestSummary.statusDesc = this.selectedRecord.requestStatusDesc;
		this.requestSummary.amountRequested = DwUtils.returnBlankForNull(this.selectedRecord.amountRequested);
		this.requestSummary.unitOfMeasure = this.selectedRecord.unitOfMeasure;
		this.requestSummary.totalAmountProvided = this.selectedRecord.totalAmountProvided !== null && this.selectedRecord.totalAmountProvided !== undefined
			? this.selectedRecord.totalAmountProvided.toString()
			: '';
		const isHistoryMode = this.selectedRecord.recordStatus === 0 || this.selectedRecord.clericalOpen === 1;
		this.requestSummary.currentNeed = isHistoryMode ? '' : this.selectedRecord.currentNeed;
		this.requestSummary.dateCompleted = this.selectedRecord.dateCompleted;
		this.requestSummary.clericalOpen = this.selectedRecord.clericalOpen;

		this.selectedRequestType = Settings.getInstance().getServiceRequestType(this.selectedRecord.serviceRequestTypeId);
		this.selectedDef = Settings.getInstance().getServiceDef(this.selectedRecord.serviceDefId);
		this.selectedServiceRequestTypeId = this.selectedRecord.serviceRequestTypeId;
		this.selectedServiceDefId = this.selectedRecord.serviceDefId;
		this.valRequestId = this.selectedRecord.id;
		this.keepOpen = this.selectedRecord.keepOpen;

		if (this.selectedRecord.startDate !== null) {
			this.startDate = DwUtils.formatDateFromString(this.selectedRecord.startDate.toString());
		}
		if (this.selectedRecord.endDate !== null) {
			this.endDate = DwUtils.formatDateFromString(this.selectedRecord.endDate.toString());
		}
		if (this.selectedRecord.unitOfMeasure) {
			this.unitOfMeasure = this.selectedRecord.unitOfMeasure.trim();
		} else {

		}
		this.valAmountRequested = this.selectedRecord.amountRequested;

		if (this.selectedRecord.flatRequestId) {
			this.requestSummary.source = 'Universal Form';
		} else {
			this.requestSummary.source = 'Data Entry';
		}
		this.requestSummary.agencyName = Settings.getInstance().getAgencyName(this.selectedRecord.agencyId);
		this.requestSummary.statusColor = this.getStatusColor(this.selectedRecord.requestStatusId);

		this.reqSummary.onShowHandler();

	}
	public setServiceType(): void {

		if (this.selectedServiceRequestTypeId > 0) {
			this.selectedRequestType = this.serviceRequestTypes.find(s => s.id === this.selectedServiceRequestTypeId);
		}
	}
	public setServiceDef(): void {

		if (this.selectedServiceDefId > 0) {
			this.selectedDef = this.serviceDefs.find(s => s.id === this.selectedServiceDefId);
		}
	}
	public getStatusColor(requestStatusId: number): string {
		switch (requestStatusId) {
			case 1:
				return 'black'; // Unmatched
			case 2:
				return 'blue'; // Matched
			case 3:
				return 'green'; // Approved
			case 4:
				return 'red'; // Denied
			case 5:
				return 'orange'; // Cancelled
			default:
				return ''; // Handle any other status or return a default color
		}
	}
	public doMatch(): void {
		const agency = Settings.getInstance().agencyList.find(s => s.id === this.selectedRecord.agencyId);
		this.matchAgencyDlg = true;
		this.matchAgency.doInitialize(agency);
	}
	public doApprove(): void {
		this.approveRequestDlg = true;
		if (this.primaryAgencyFlag === false) {
			this.dialogHeaderText = 'Collaborate Request';
		}
		else {
			this.dialogHeaderText = 'Approve Request';
		}
		this.approveRequest.onShowHandler();
	}
	public doStatus(): void {
		this.assignStatusDlg = true;
		this.assignStatus.onShowHandler();
	}
	public doReOpenRequest(): void {

		// Remove record logic
		const message = 'Open this Service Request?:  - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {

				this.serviceRequestsService.reOpenClosedRequest(this.selectedRecord.id).subscribe(
					(result) => {
						this.selectedRecord.recordStatus = result.recordStatus;
						this.selectedRecord.requestStatusId = result.requestStatusId;
						this.selectedRecord.requestStatusDesc = Settings.getInstance().requestStatuses.find(s => s.id === this.selectedRecord.requestStatusId).shortDescription;
						this.selectedRecord.clericalOpen = result.clericalOpen;
						this.selectedRecord.dateCompleted = result.dateCompleted ?? null;
						this.setRequestSummary();
						this.loadMembers();
						/** create a transaction history record **/
						this.txService.createTransactionHistory('ServiceRequests', this.selectedRecord.id,
							'Re-open', 'Closed record reopened by administrator');
					},
					(error) => {
						Settings.getInstance().handleError(error, 'Reopening close request')
					});
			}
		});
	}
	public approveRequestSubmitted(sr: ServiceRequest): void {
		this.approveRequestDlg = false;
		this.selectedRecord.totalAmountProvided = sr.totalAmountProvided;
		this.selectedRecord.requestStatusDesc = this.requestStatuses.find(s => s.id === this.selectedRecord.requestStatusId).shortDescription;
		this.selectedRecord.dateCompleted = sr.dateCompleted;
		this.selectedRecord.dateCreated = sr.dateCreated;
		this.selectedRecord.clericalOpen = sr.clericalOpen;
		this.setRequestSummary();

	}
	public submitMatchRequest(event: any): void {

		this.selectedRecord.agencyId = event.agencyId;
		this.selectedRecord.requestStatusId = event.requestStatusId;
		this.selectedRecord.serviceDefId = event.serviceDefId;
		this.selectedRecord.requestStatusDesc = event.requestStatusDesc;
		//this.updateSelectedRow();
		/** request summary info **/

		this.matchAgencyDlg = false;
		this.setRequestSummary();
		this.setControlButtons();
	}
	public doAssignStatusSubmitted(event: any): void {

		if (event === undefined) {
			return;
		}

		this.selectedRecord.recordStatus = event.recordStatus;
		this.selectedRecord.requestStatusId = event.requestStatusId;
		this.selectedRecord.statusReasonId = event.statusReasonId;
		this.selectedRecord.requestStatusDesc = this.requestStatuses.find(s => s.id === this.selectedRecord.requestStatusId).shortDescription;
		this.selectedRecord.dateCompleted = event.dateCompleted;
		this.selectedRecord.dateCreated = event.dateCreated;
		this.selectedRecord.clericalOpen = event.clericalOpen;
		//this.selectedRecord.dateCompleted = new Date();
		/** update the summary tab **/
		this.setRequestSummary();

		/** temporarily reset the record-status to 0
		 * This way the buttons will be disabled **/

		this.selectedRecord.recordStatus = 0;
	}

	public toggleAllSelected(event): void {

		if (this.dataSource === undefined) {
			return;
		}

		for (const item of this.dataSource.filteredData) {
			item['select'] = event.checked;
		}
	}

	public runChecked(event: any, element: any): void {
		/** For closed and clerically-reopened requests, persist the check/uncheck into the history table immediately **/
		if (this.selectedRecord && (this.selectedRecord.recordStatus === 0 || this.selectedRecord.clericalOpen === 1)) {
			if (element && element['historyId']) {
				const newSelected = event.checked ? 1 : 0;
				this.casesService.updateMemberHistorySelected(element['historyId'], newSelected).subscribe(
					() => {
						this.logMemberSelectionAudit(element, newSelected === 1);
					},
					() => Settings.getInstance().handleError('Error: unable to update member history selection')
				);
			}
		}
	}

	/** Mirror of runChecked() but handles Advocate table (dataSourceAdv) **/
	public runCheckedAdv(event: any, element: any): void {
		if (this.selectedRecord && (this.selectedRecord.recordStatus === 0 || this.selectedRecord.clericalOpen === 1)) {
			if (element && element['historyId']) {
				const newSelected = event.checked ? 1 : 0;
				this.casesService.updateMemberHistorySelected(element['historyId'], newSelected).subscribe(
					() => {
						this.logMemberSelectionAudit(element, newSelected === 1, true);
					},
					() => Settings.getInstance().handleError('Error: unable to update advocate history selection')
				);
			}
		}
	}

	private logMemberSelectionAudit(element: any, included: boolean, isAdvocate: boolean = false): void {
		if (!this.selectedRecord?.id) {
			return;
		}
		const label = (element?.member || element?.relationship || (isAdvocate ? 'Advocate' : 'Member')).trim();
		const action = included ? 'Included on request: ' : 'Excluded from request: ';
		this.txService.createTransactionHistory(
			'ServiceRequests',
			this.selectedRecord.id,
			'Edit',
			action + label,
			included ? 'Yes' : 'No',
			isAdvocate ? 'advocate' : 'member'
		);
	}
}
